import _axios from "@/plugins/axios";
export const analyticsScriptStep = async (payload) => {
    return await _axios.post('/analytics/script/step', payload);
};
